import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSidemenuReporting = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(1.6 0) scale(1.6)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.11111 6.85H3.44444M4.66667 9.45H3.44444M8.33333 4.25H3.44444M10.7778 6.525V4.12C10.7778 3.0279 10.7778 2.48185 10.578 2.06472C10.4022 1.6978 10.1217 1.39949 9.77676 1.21254C9.38459 1 8.87121 1 7.84444 1H3.93333C2.90657 1 2.39319 1 2.00102 1.21254C1.65605 1.39949 1.37559 1.6978 1.19982 2.06472C1 2.48185 1 3.0279 1 4.12V10.88C1 11.9721 1 12.5182 1.19982 12.9353C1.37559 13.3022 1.65605 13.6005 2.00102 13.7875C2.39319 14 2.90657 14 3.93333 14H5.58333M12 14L11.0833 13.025M11.6944 11.4C11.6944 12.6564 10.7368 13.675 9.55556 13.675C8.37428 13.675 7.41667 12.6564 7.41667 11.4C7.41667 10.1436 8.37428 9.125 9.55556 9.125C10.7368 9.125 11.6944 10.1436 11.6944 11.4Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgSidemenuReporting);
export default ForwardRef;
